module.exports = __webpack_public_path__ + "static/media/logo512.3d2234d1.png";